import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  circle: {
    height: "24px",
    width: "24px",
    borderRadius: "12px"
  },
  circleSmall: {
    height: "12px",
    width: "12px",
    borderRadius: "6px"
  }
}));

export function MapCircleIcon(props) {
  const classes = useStyles();
  return (
    <div
      className={props.size === 'small' ? classes.circleSmall : classes.circle}
      style={{
        background: props.difference
          ? "linear-gradient(45deg, red 49%, green 51%)"
          : props.color
      }}
    />
  );
}